import React from 'react';

const WidgetTableauBlancSvg = ({width = 20, height = 20, couleur = "#A8B0B3"}) => (
    <svg width={width} height={height} viewBox="0 0 36 28" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M6 0H30C32.1875 0 34 1.8125 34 4V22H30V4H6V22H2V4C2 1.8125 3.75 0 6 0ZM14 22C14 20.9375 14.875 20 16 20H24C25.0625 20 26 20.9375 26 22V24H34C35.0625 24 36 24.9375 36 26C36 27.125 35.0625 28 34 28H2C0.875 28 0 27.125 0 26C0 24.9375 0.875 24 2 24H14V22Z"
            fill={couleur}/>
    </svg>
);

export default WidgetTableauBlancSvg;
